// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.commutably {
  --button-font-size: 1.1em;
  --button-border-radius: 12px;
  --button-padding-y: 0.6em;
  --button-padding-x: 0.8em;
  --button-transition-duration: 170ms;

  --button-rest-shadow: var(--shadow-0);
  --button-rest-transform: perspective(100px) translate3d(0, 0, 0);
  --button-active-shadow: var(--shadow-0);
  --button-active-transform: perspective(100px) translate3d(0, 1px, -1px);

  --button-elevated-rest-shadow: var(--shadow-2);
  --button-elevated-rest-transform: perspective(100px) translate3d(0, -2px, 1px);
  --button-elevated-active-shadow: var(--shadow-1);
  --button-elevated-active-transform: perspective(100px) translate3d(0, 1px, -1px);

  --button-focus-outline: var(--default-focus-outline);
  --button-focus-outline-offset: 3px;

  --button-paper1-color-main: var(--color-grey-0);
  --button-paper1-color-text: black;

  --button-paper2-color-main: var(--color-grey-3);
  --button-paper2-color-text: var(--color-grey-2);

  --button-ink-color-main: black;
  --button-ink-color-text: white;

  --button-accent-color-main: var(--color-purple-1);
  --button-accent-color-text: white;

  --button-success-color-main: var(--color-green-1);
  --button-success-color-text: white;

  --button-destructive-color-main: var(--color-red-2);
  --button-destructive-color-text: white;

  --button-info-background: var(--gradient-blue-1);
  --button-info-color-main: var(--color-blue-1);
  --button-info-color-text: white;
}
`, "",{"version":3,"sources":["webpack://./src/theme/components/Button.css"],"names":[],"mappings":"AAAA;EACE,yBAAyB;EACzB,4BAA4B;EAC5B,yBAAyB;EACzB,yBAAyB;EACzB,mCAAmC;;EAEnC,qCAAqC;EACrC,gEAAgE;EAChE,uCAAuC;EACvC,uEAAuE;;EAEvE,8CAA8C;EAC9C,8EAA8E;EAC9E,gDAAgD;EAChD,gFAAgF;;EAEhF,oDAAoD;EACpD,kCAAkC;;EAElC,+CAA+C;EAC/C,iCAAiC;;EAEjC,+CAA+C;EAC/C,+CAA+C;;EAE/C,8BAA8B;EAC9B,8BAA8B;;EAE9B,iDAAiD;EACjD,iCAAiC;;EAEjC,iDAAiD;EACjD,kCAAkC;;EAElC,mDAAmD;EACnD,sCAAsC;;EAEtC,gDAAgD;EAChD,6CAA6C;EAC7C,+BAA+B;AACjC","sourcesContent":[".commutably {\n  --button-font-size: 1.1em;\n  --button-border-radius: 12px;\n  --button-padding-y: 0.6em;\n  --button-padding-x: 0.8em;\n  --button-transition-duration: 170ms;\n\n  --button-rest-shadow: var(--shadow-0);\n  --button-rest-transform: perspective(100px) translate3d(0, 0, 0);\n  --button-active-shadow: var(--shadow-0);\n  --button-active-transform: perspective(100px) translate3d(0, 1px, -1px);\n\n  --button-elevated-rest-shadow: var(--shadow-2);\n  --button-elevated-rest-transform: perspective(100px) translate3d(0, -2px, 1px);\n  --button-elevated-active-shadow: var(--shadow-1);\n  --button-elevated-active-transform: perspective(100px) translate3d(0, 1px, -1px);\n\n  --button-focus-outline: var(--default-focus-outline);\n  --button-focus-outline-offset: 3px;\n\n  --button-paper1-color-main: var(--color-grey-0);\n  --button-paper1-color-text: black;\n\n  --button-paper2-color-main: var(--color-grey-3);\n  --button-paper2-color-text: var(--color-grey-2);\n\n  --button-ink-color-main: black;\n  --button-ink-color-text: white;\n\n  --button-accent-color-main: var(--color-purple-1);\n  --button-accent-color-text: white;\n\n  --button-success-color-main: var(--color-green-1);\n  --button-success-color-text: white;\n\n  --button-destructive-color-main: var(--color-red-2);\n  --button-destructive-color-text: white;\n\n  --button-info-background: var(--gradient-blue-1);\n  --button-info-color-main: var(--color-blue-1);\n  --button-info-color-text: white;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
